/* unplugin-vue-components disabled */import { render } from "./MyWallet.vue?vue&type=template&id=eee44a14&scoped=true"
import script from "./MyWallet.vue?vue&type=script&lang=js"
export * from "./MyWallet.vue?vue&type=script&lang=js"

import "./MyWallet.vue?vue&type=style&index=0&id=eee44a14&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eee44a14"]])

export default __exports__